import { config } from "config";
import format from "date-fns/format";
import { change, reset } from "redux-form";
import { fields } from ".";
import MyForm from "components/templates/MyForm";
import { useAppDispatch } from "redux/hooks";
import { assetManagementActions } from "redux/slices/assetManagement/assetManagementSlice";

export default function ECarsFilters() {
    const form = "ECarsFiltersForm";
    const dispatch = useAppDispatch();

    const onClickReset = () => {
        const default_page_size = config.PAGE_SIZE;
        dispatch(assetManagementActions.resetECarsFilters());
        dispatch(reset(form));
        dispatch(change(form, "page_size", default_page_size));
    };

    const handleSubmit = (values: any) => {
        const default_page_size = config.PAGE_SIZE;
        let data: any = { page: 1, page_size: default_page_size };
        const { driver_id, vehicle_id, partner_id, status, date, page_size } = values;

        // The combo boxes hand back { value, label }; guard for a raw id too so a
        // persisted/pre-set filter value still works.
        if (driver_id) data.driver_id = driver_id?.value || driver_id;
        if (vehicle_id) data.vehicle_id = vehicle_id?.value || vehicle_id;
        // if (partner_id) data.partner_id = partner_id?.value || partner_id;
        if (status) data.status = status?.value || status;
        if (page_size) data.page_size = Number(page_size);

        if (date && date.date[0] && date.date[1]) {
            data.end_date = format(new Date(date.date[1]), "yyyy-MM-dd");
            data.start_date = format(new Date(date.date[0]), "yyyy-MM-dd");
        }

        dispatch(assetManagementActions.setECarsFilters(data));
    };

    return (
        <div className="filters">
            <MyForm
                form={form}
                myFields={fields}
                onSubmit={handleSubmit}
                onClickReset={onClickReset}
            />
        </div>
    );
}
